import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { Evento, MezzoTrasporto } from '../../../../shared/interface';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-mezzi-trasporto-accrediti-backoffice',
  templateUrl: './mezzi-trasporto-accrediti-backoffice.component.html',
  styleUrls: ['./mezzi-trasporto-accrediti-backoffice.component.css']
})
export class MezziTrasportoAccreditiBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute
  ) {}

  @ViewChild('delete') delete!: ConfirmPopup;
  @Input() mezzi: MezzoTrasporto[] = [];
  @Input() evento?: Evento
  
  mezzo?: MezzoTrasporto;

  loading: boolean = false;
  add: boolean = false;
  edit: boolean = false;


  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.mezzi = changes['mezzi']?.currentValue || this.mezzi;
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDelete(event: Event, mezzo: MezzoTrasporto) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler rimuovere il mezzo di trasporto?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteMezzoTrasporto(mezzo.id).subscribe({
          next: (data) => this.apiService.setMezziTrasportoEvento(this.evento?.id!),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.message("success", "Eliminazione", "Il mezzo di trasporto è stato eliminato con successo!")
          }
        })
      },
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onClose() {
    this.delete.reject();
  }

  onOpenEdit(mezzo: MezzoTrasporto) {
    this.mezzo = mezzo;
    this.edit = true;    
  }

  onCloseEdit(close: any) {
    this.edit = false;
    this.mezzo = undefined;
  }

}
